// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2CQOA","itemTitle":"ClientEmergencyInfo_itemTitle__UY7R0","itemText":"ClientEmergencyInfo_itemText__1FJQB"};